import { ColumnsType } from "antd/es/table";
import AntTable from "../../components/table/Table";
import {
    EditOutlined,
    DeleteOutlined
} from "@ant-design/icons";
import { Avatar, Button, Flex, Image, Modal, Space, notification } from "antd";
import { useState } from "react";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import CreateTopup from "./CreateTopup";
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import { RewardService } from "../../services/RewardService";


export default function Topup() {

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [editRecord, setEditRecord] = useState<object>()
    const [refreshData, setRefreshData] = useState<boolean>(false)
   

    const [tab, setTab] = useState<string>("coupons")

    const [columns] = useState<ColumnsType<any>>([
        {
            title: 'Id',
            align: 'center',
            dataIndex: 'id',
            key: 'id',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'User',
            align: 'center',
            dataIndex: 'user',
            key: 'user',
            render: (value, record) => {
                return `ID: ${value.id} ${value?.full_name} ${value?.deleted_at  ? '(Deactive)' : ''}`
            },
        },
        {
            title: 'Points',
            align: 'center',
            dataIndex: 'points',
            key: 'points',
            sorter: true,
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Reason',
            align: 'center',
            dataIndex: 'reason',
            key: 'reason',
            render: (value, record) => {
                return value
            },
        },
      
        {
            title: 'Created Date',
            align: 'center',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (value, record) => {
                return (value && moment(value).isValid()) ? moment(value).format('DD-MM-YYYY HH:mm') : ''
            },
        },
        {
            title: '',
            align: 'center',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text, record: any) => {
                return (
                    <Flex gap="small" wrap="wrap">
                        <div onClick={() => {
                            setIsModalOpen(true)
                            setEditRecord(record)
                        }} >
                            <Button type="primary" icon={<EditOutlined></EditOutlined>}></Button>
                        </div>
                        <div onClick={() => onDelete(record.id)} >
                            <Button type={'primary'} danger icon={<DeleteOutlined></DeleteOutlined>}></Button>
                        </div>
                    </Flex>
                )
            }
        },

    ])


    const onLoadData = async (params: any = {}) => {
        const payload = {
            ...params,
        }
        const res = await RewardService.getTopups(payload)
    
      
        return res
    }



    const onDelete = async (id: number) => {
        const res = await RewardService.deleteTopup(id)

        if (res.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            setRefreshData(p => !p)
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    }





    return (
        <>

            <Modal
                title=""
                open={isModalOpen}
                onOk={() => setIsModalOpen(true)}
                onCancel={() => setIsModalOpen(false)}
                footer={null}>
                <CreateTopup
                    record={editRecord}
                    onFinish={() => {
                        setIsModalOpen(false)
                        setRefreshData(p => !p)
                    }}
                ></CreateTopup>
            </Modal>
            <AntTable
                refresh={refreshData}
                menuOptions={[{
                    label: 'Create Topup',
                    key: 'create'
                }]}
                menuClick={(e) => {
                    if (e.key == 'create') {
                        setEditRecord({});
                        setIsModalOpen(true)
                    }

                }}
                search
                title="Manage Topup"
                columns={columns}
                onLoadData={onLoadData}
            />

        </>
    )
}
